import React, { Component } from "reactn";
import { _ } from "js/vendor";

class SearchInput extends Component {
    state = {
        searchInput: ""
    };

    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.prefilledSearch) {
            this.setState({
                searchInput: this.props.prefilledSearch
            });
        }
        this.props.focus && this.inputRef.current.focus();
    }

    componentDidUpdate(prevProps, prevState) {
        const { onChange, prefilledSearch, focus } = this.props;
        const { searchInput } = this.state;

        if (prefilledSearch && prevProps.prefilledSearch !== prefilledSearch && prefilledSearch !== searchInput) {
            this.setState({ searchInput: prefilledSearch }, () => {
                if (focus) {
                    this.inputRef.current.focus();
                }
            });
        }

        if (prevProps.focus !== focus && focus) {
            this.inputRef.current.focus();
        }

        if (onChange && prevState.searchInput !== searchInput) {
            onChange(searchInput);
        }
    }

    handleKeyUp = e => {
        // trying to submit
        if (e.key === "Enter") {
            // verify that there's input
            const {
                handleSubmit,
                allowEmptySubmit,
            } = this.props;
            const searchInput = _.trim(this.state.searchInput);
            const hasSearch = !!searchInput;
            if (hasSearch || allowEmptySubmit) {
                handleSubmit(searchInput);
            }
        }
    }

    handleOnChange = e => {
        this.setState({
            searchInput: e.currentTarget.value
        });
    };

    clearSearch = () => {
        const { handleClearSearch } = this.props;
        this.setState({
            searchInput: ""
        });
        handleClearSearch && handleClearSearch();
    };

    render() {
        const { className, placeholder, onMouseEnter = () => { }, onMouseLeave = () => { } } = this.props;
        const { searchInput } = this.state;

        return (
            <div className={`searchbar ${className}`}>
                <i className="micon">search</i>
                <input
                    onKeyUp={this.handleKeyUp}
                    onChange={e => this.handleOnChange(e)}
                    spellCheck="false"
                    type="text"
                    ref={this.inputRef}
                    placeholder={placeholder}
                    value={searchInput}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                />
                <i
                    className="micon clear_search"
                    onClick={this.clearSearch}
                    style={{
                        display:
                            searchInput && searchInput !== ""
                                ? "inline"
                                : "none"
                    }}
                >
                    cancel
                </i>
            </div>
        );
    }
}

export default SearchInput;
